// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__SYfoi","footer":"ModalUpdate_footer__1F6jQ"};